function stripHashSuffix(dynamicKey) {
  if (typeof dynamicKey !== 'string') return dynamicKey;
  return dynamicKey.replace(/_[0-9a-f]{6,}$/i, '');
}

export function buildLogicalNameToFieldKey(fields) {
  const map = {};
  if (!Array.isArray(fields)) return map;

  fields.forEach((f) => {
    const logicalName = f?.mapFieldKey;
    const fieldKey = f?.fieldKey || f?.FieldKey;
    if (!logicalName || !fieldKey) return;
    const normalized = String(logicalName).trim().toLowerCase();
    if (!map[normalized]) map[normalized] = fieldKey;
  });

  return map;
}

export function mapBackendFieldErrors(backendFields, templateFields, staticFieldMap = {}) {
  if (!Array.isArray(backendFields) || backendFields.length === 0) return null;

  const logicalNameToFieldKey = buildLogicalNameToFieldKey(templateFields);
  const result = {};

  backendFields.forEach((entry) => {
    const fieldName = entry?.fieldName;
    const message = entry?.errorMsg;
    if (!fieldName || !message) return;

    const normalized = String(fieldName).trim().toLowerCase();
    const fieldKey = logicalNameToFieldKey[normalized]
      ?? logicalNameToFieldKey[stripHashSuffix(normalized)]
      ?? staticFieldMap[normalized]
      ?? staticFieldMap[stripHashSuffix(normalized)];
    if (!fieldKey) return;

    result[fieldKey] = message;
  });

  return Object.keys(result).length > 0 ? result : null;
}
